import { Badge } from 'antd'
import { useTranslation } from 'react-i18next'

export function ComplaintStateBadge ({ state }) {
  const i18n = useTranslation('translation', { keyPrefix: 'common.resources.complaint.values.state' })
  const text = i18n.t(`${state}.label`)
  const status = i18n.t(`${state}.status`)
  return (
    <Badge
      status={status}
      text={text}
    />
  )
}
